import { UitkCardTextSegment } from "uitk-react-cards";
import { CardContentReviewsPriceProposition } from "./CardContentReviewsPriceProposition";
import * as React from "react";
import { Hotel, HotelsFlexModuleResult } from "src/typings/microserviceModels/hotels-flex-module";
import { ExtendedContextStore } from "typings/flexFramework/FlexDefinitions";

export const CardContent = ({
  hotel,
  model,
  context,
  locale,
  isViewCarousel
}: {
  hotel: Hotel;
  model: HotelsFlexModuleResult;
  context: ExtendedContextStore;
  locale: string;
  isViewCarousel?: boolean;
}) => {
  return (
    <UitkCardTextSegment className="first">
      <CardContentReviewsPriceProposition
        hotel={hotel}
        context={context}
        locale={locale}
        showDistance={model.showDistance}
        showAddress={model.showAddress}
        isViewCarousel={isViewCarousel}
        shouldUseImperialDistanceUnits={model.shouldUseImperialDistanceUnits}
        addressDistanceView={model.addressDistanceView}
      />
    </UitkCardTextSegment>
  );
};
